var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUnshowPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3,.cls-4{fill:none;stroke-linecap:round;stroke-width:30px;}.cls-1,.cls-4{stroke:#d1d1d1;}.cls-1{stroke-miterlimit:10;}.cls-2{fill:#d1d1d1;}.cls-3{stroke:#fff;}.cls-3,.cls-4{stroke-linejoin:round;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ICON_Show Password") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_2",
    "data-name": "Artboard 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.36,509.21s148.07-274.6,485.23-274.6,486.05,274.6,486.05,274.6"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 540,
    cy: 593.36,
    r: 248.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 201.42,
    y1: 244.04,
    x2: 856.24,
    y2: 829.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 176.19,
    y1: 268.87,
    x2: 830.82,
    y2: 853.98
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnshowPassword);
export default __webpack_public_path__ + "static/media/ICON_UnshowPassword.5d2f2b71ef8aec613b94c686557531a8.svg";
export { ForwardRef as ReactComponent };